<template>
  <ul id="mobile-menu" class="md:flex">
    <li class="md:mx-6" v-if="!auth && !isMaintenanceMode">
      <router-link to="/" v-slot="{ href, navigate, isActive }">
        <a
          class="block font-normal font-normal border-transparent border-l-4 pl-8 text-base h-12 flex items-center relative text-gray-600 md:font-semibold md:pl-0 md:border-l-0 md:h-14 hover:text-gray-700 hover:no-underline"
          :class="[isActive ? 'border-blue-700' : '']"
          :href="href"
          @click="navigate"
        >
          Sign in
          <span
            :class="{
              'absolute inset-x-0 bottom-0 hidden w-full h-1 bg-blue-700 rounded-sm md:block': isActive
            }"
          ></span>
        </a>
      </router-link>
    </li>
    <li class="md:mx-6" v-if="auth && !isMaintenanceMode">
      <router-link to="/my-students" v-slot="{ href, navigate, isActive }">
        <a
          class="block font-normal font-normal border-transparent border-l-4 pl-8 text-base h-12 flex items-center relative text-gray-600 md:font-semibold md:pl-0 md:border-l-0 md:h-14 hover:text-gray-700 hover:no-underline"
          :class="[isActive ? 'border-blue-700' : '']"
          :href="href"
          @click="navigate"
        >
          <span>My students</span>
          <span
            :class="{
              'absolute inset-x-0 bottom-0 hidden w-full h-1 bg-blue-700 rounded-sm md:block': isActive
            }"
          ></span>
        </a>
      </router-link>
    </li>
    <li class="md:mx-6 md:hidden sm:block" v-if="auth">
      <router-link
        to="/notification-settings"
        v-slot="{ href, navigate, isActive }"
      >
        <a
          class="block font-normal font-normal border-transparent border-l-4 pl-8 text-base h-12 flex items-center relative text-gray-600 md:font-semibold md:pl-0 md:border-l-0 md:h-14 hover:text-gray-700 hover:no-underline"
          :class="[isActive ? 'border-blue-700' : '']"
          :href="href"
          @click="navigate"
        >
          <span>Notification Settings</span>
          <span
            :class="{
              'absolute inset-x-0 bottom-0 hidden w-full h-1 bg-blue-700 rounded-sm md:block': isActive
            }"
          ></span>
        </a>
      </router-link>
    </li>

    <li class="md:hidden" v-if="auth">
      <a
        class="block font-normal font-normal border-transparent border-l-4 pl-8 text-base h-12 flex items-center relative text-gray-600 md:font-semibold md:pl-0 md:border-l-0 md:h-14 hover:text-gray-700 hover:no-underline"
        href="#"
        @click="$emit('logout')"
      >
        Log out
      </a>
    </li>
    <li
      class="md:mx-6 md:hidden sm:block pl-8"
      v-if="auth && dynamicUniversity"
    >
      <universityChange class="w-90-p" :showCurrent="true" />
    </li>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";
import universityChange from "@/components/SiteComponents/header/universityChange.vue";

export default {
  name: "mobileMenu",
  components: {
    universityChange
  },
  computed: {
    ...mapGetters(["dynamicUniversity"]),
    isMaintenanceMode() {
      return (
        process.env.VUE_APP_MAINTENANCE_MODE &&
        process.env.VUE_APP_MAINTENANCE_MODE.toLowerCase() === "true"
      );
    },
    auth() {
      return this.$store.getters.isLoggedIn;
    }
  }
};
</script>

<style>
.w-90-p {
  width: 90%;
}
</style>
